import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { Users, Role } from 'src/app/models/um/organization';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-um-role-map-users-view-modal',
  templateUrl: './um-role-map-users-view-modal.component.html',
  styleUrls: ['./um-role-map-users-view-modal.component.scss']
})
export class UmRoleMapUsersViewModalComponent implements OnInit {
  @Input() public Content: any;
  content: any;
  heading: string;
  action: Subject<any> = new Subject();
  roles: Role[];
  selectedroles: Role[];
  selectedroleids: string[];
  availableroles: Role[];
  availableroleids: string[];
  changedroles: Role[];
  searchFilter: string="";
  selectedCount:number=0;
  constructor(
    public modalRef: NgbActiveModal,
    private modalService: NgbModal,
    private summaryService: UmSummaryService,
    private commonservice: CommonService,
  ) {
  }
  ngOnInit() {
    this.getRoles();
  }
  getRoles() {
    this.summaryService.getActiveDashboards().subscribe(summary => {
      debugger
      let Roles= summary["Data"];
      this.roles=[];
      Roles.forEach(element => {
        if(this.Content.content.selectedIds.indexOf(element.value)==-1)
        {
            element["IsMarked"]=false;
            this.roles.push(element);
        }
      });
    });
  }
  
  CancelPopup() { 
    this.modalRef.dismiss();
  }
  SaveRoles()
  { 
    debugger;
    let selectedIds = [];
    if (this.roles.length > 0) {
      selectedIds = this.roles.filter(function (a) {
        return (a["IsMarked"] == true)
      });
    }
    if (selectedIds.length == 0) {
      this.commonservice.ValidationBanner("Please select atleast one Dashboard");
    }
    else {
      //this.action.next(selectedIds);
      this.modalRef.close(selectedIds);
    }
  }
  collectRoles(roleid) {
    debugger;
    this.selectedCount=0;
    this.roles.forEach((item: any) => {
      if (item.value == roleid) {
        if (item.IsMarked)
          item.IsMarked = false;
        else
          item.IsMarked = true;
      }
      if(item.IsMarked==true)
      {
        this.selectedCount=this.selectedCount+1;
      }
    });
  }
}